import { GameApp } from "@casino/game-framework";
import { SolitaireGame } from "./SolitaireGame";
import { MenuManager } from "./MenuManager";

// Base game dimensions (design resolution)
const DESIGN_WIDTH = 1280;
const DESIGN_HEIGHT = 720;

async function main() {
  const container = document.getElementById("game-root") as HTMLElement;

  if (!container) {
    throw new Error("Game root container not found");
  }
  
  const app = new GameApp(container, {
    width: DESIGN_WIDTH,
    height: DESIGN_HEIGHT,
    backgroundColor: 0x0a5d2e,
  });

  await app.waitForInit();

  const game = new SolitaireGame(app);
  game.init();
  game.start();

  // Setup automatic resizing (handles ResizeObserver, window resize, fullscreen, etc.)
  // fillMode: true makes canvas fill all available space
  app.setupAutoResize(container, DESIGN_WIDTH, DESIGN_HEIGHT, true);

  // Enable double-click to toggle fullscreen (entire HTML page)
  container.addEventListener("dblclick", async () => {
    try {
      const isFullscreen = !!(
        document.fullscreenElement ||
        (document as any).webkitFullscreenElement ||
        (document as any).mozFullScreenElement ||
        (document as any).msFullscreenElement
      );

      if (isFullscreen) {
        // Exit fullscreen
        if (document.exitFullscreen) {
          await document.exitFullscreen();
        } else if ((document as any).webkitExitFullscreen) {
          await (document as any).webkitExitFullscreen();
        } else if ((document as any).mozCancelFullScreen) {
          await (document as any).mozCancelFullScreen();
        } else if ((document as any).msExitFullscreen) {
          await (document as any).msExitFullscreen();
        }
      } else {
        // Enter fullscreen on entire page
        const docElement = document.documentElement;
        if (docElement.requestFullscreen) {
          await docElement.requestFullscreen();
        } else if ((docElement as any).webkitRequestFullscreen) {
          await (docElement as any).webkitRequestFullscreen();
        } else if ((docElement as any).mozRequestFullScreen) {
          await (docElement as any).mozRequestFullScreen();
        } else if ((docElement as any).msRequestFullscreen) {
          await (docElement as any).msRequestFullscreen();
        } else {
          throw new Error("Fullscreen API not supported");
        }
      }
    } catch (error) {
      console.warn("Fullscreen toggle failed:", error);
    }
  });

  // Expose fullscreen API globally for debugging
  (window as any).__GAME_APP__ = app;

  // Setup menu manager
  const menuManager = new MenuManager(game);
  
  // Connect menu's new game button to UIManager's handler
  game.setMenuManager(menuManager);
}

main().catch((error) => {
  console.error("Failed to start game:", error);
});
